import { Typography } from '@evocolabs/orkaui'
import { Box } from '@mui/material'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/virtual'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import 'swiper/css/effect-cube'
import 'swiper/css/pagination'
import SwiperCore, { FreeMode, Navigation, Autoplay, Pagination } from 'swiper'

import { ArrowBack, ArrowForward } from '@/src/components/Icon/Arrow'
import Aids from '@/src/components/Icon/Aids'

import style from '@/pages/scss/OrkaTwo.module.scss'

import React, { useRef } from 'react'

const dataTitle = 'Why Our Customers Love Their Orka Two'
const data = [
  {
    title:
      '“Big improvement in the sound quality. I can now, with the new app, easily control what I want to hear. In loud surroundings it is easy to control back ground noises due to the enhanced DeNoise technology. Also a very good improvement in the charging case touch buttons volume and mode control…”',
    user: 'Detlef Wittmacher',
    date: '08/07/2023'
  },
  {
    title:
      '“Flexibility in Post-COVID era COVID hit just when I was thinking of making an appointment, to update the audiogram profile for my previous hearing aids. MUCH more convenient using the Orka app to update audiogram on my own.”',
    user: 'Bobby Wang',
    date: '08/03/2023'
  },
  {
    title:
      '“The sound quality is good. I certainly hear more higher-frequency sounds than without the HAs.”',
    user: 'Jon Wegner',
    date: '07/31/2023'
  },
  {
    title: `“The overall sound quality is excellent. Now that the spring bird migration is on, I am very pleased at how much the Orka Twos help me hear the birds.”`,
    user: 'Paul Shay',
    date: '07/24/2023'
  },
  {
    title: `“I think I mentioned this before that Orka hearing aids are the only ones I have ever tested where musical instruments sound true to their acoustical sound quality. I have been playing guitar ever since I was 17 years old. I'm 73 now and no other hearing aids sound like these. Most of them make string instruments sound tinty and distorted. ”`,
    user: 'David',
    date: '07/20/2023'
  }
]

SwiperCore.use([Navigation])
const ProductEvaluate = function ({
  source = data,
  title = dataTitle
} = props) {
  const swiperRef = useRef()
  const goto = function (isNext = true) {
    if (isNext) {
      swiperRef.current.swiper.slideNext()
    } else {
      swiperRef.current.swiper.slidePrev()
    }
  }
  return (
    <Box
      mt="96px"
      sx={{
        ' .swiper-pagination': { position: 'relative', marginTop: '48px' },
        ' .swiper-pagination-bullet': {
          border: 'solid 2px #506A8A',
          opacity: '1',
          width: '10px',
          height: '10px',
          backgroundColor: 'transparent'
        },
        ' .swiper-pagination-bullet-active': { backgroundColor: '#506A8A' },
        '>.swiper>.swiper-wrapper>.swiper-slide': {
          backgroundColor: 'transparent'
        },
        '.product-aids': {
          transform: {
            xs: 'translateX(-50%) translateY(35px)',
            dl: 'translateX(-50%) translateY(15px)'
          }
        }
      }}
    >
      <Typography variant="h2" sx={{ textAlign: 'center' }}>
        {title}
      </Typography>
      <Aids
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%) translateY(15px)'
        }}
        className="product-aids"
      />
      <Swiper
        loop={true}
        autoplay={{
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          delay: 5000
        }}
        ref={swiperRef}
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
          '--swiper-pagination-bottom': '24px',
          width: '100%',
          paddingTop: '40px'
        }}
        spaceBetween={10}
        slidesPerView={1}
        navigation={{
          prevEl: null,
          nextEl: null
        }}
        pagination={true}
        modules={[FreeMode, Navigation, Pagination, Autoplay]}
        grabCursor={true}
        className={style['img-swiper']}
      >
        {source.map((data, index) => (
          <SwiperSlide
            className={style['swiper-slide']}
            key={index}
            virtualIndex={index}
          >
            <Box
              padding={{ xs: '0', dl: '0 120px' }}
              minHeight={{ xs: '0', dl: '160px' }}
            >
              <Typography
                variant="body1"
                color="#26201F"
                sx={{ textAlign: 'center' }}
              >
                {data.title}
              </Typography>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                mt="24px"
              >
                <Typography variant="t1" color="#4E4947" mb="4px">
                  {data.user}
                </Typography>
                <Typography variant="body4" color="#756F6E">
                  {data.date}
                </Typography>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
        <Box
          position="absolute"
          width="100%"
          bottom={{ xs: '11px', dl: '50%' }}
          zIndex={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            className="custom-prev-btn"
            mr="16px"
            onClick={() => goto(false)}
            sx={{ pointerEvents: 'all' }}
          >
            <ArrowBack
              strokeWidth="1.5"
              fill="transparent"
              hoverFill="#000"
              hoverOpacity={0.1}
            />
          </Box>
          <Box
            className="custom-next-btn"
            onClick={() => goto()}
            sx={{ pointerEvents: 'all' }}
          >
            <ArrowForward
              strokeWidth="1.5"
              fill="transparent"
              hoverFill="#000"
              hoverOpacity={0.1}
            />
          </Box>
        </Box>
      </Swiper>
    </Box>
  )
}

export default ProductEvaluate
